var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16329 15.9628C12.3757 15.9628 14.9799 13.4106 14.9799 10.2623C14.9799 7.11405 12.3757 4.56185 9.16329 4.56185C5.95084 4.56185 3.34664 7.11405 3.34664 10.2623C3.34664 13.4106 5.95084 15.9628 9.16329 15.9628ZM9.16329 16.9993C12.9598 16.9993 16.0375 13.9831 16.0375 10.2623C16.0375 6.54163 12.9598 3.52539 9.16329 3.52539C5.36676 3.52539 2.28906 6.54163 2.28906 10.2623C2.28906 13.9831 5.36676 16.9993 9.16329 16.9993Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7417 4.15779C11.7417 5.66933 10.4914 6.89467 8.94903 6.89467C7.40669 6.89467 6.15637 5.66933 6.15637 4.15779C6.15637 2.64624 7.40669 1.4209 8.94903 1.4209C10.4914 1.4209 11.7417 2.64624 11.7417 4.15779Z",
    fill: "white",
    stroke: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3258 13.4215C17.3258 14.933 16.0755 16.1583 14.5331 16.1583C12.9908 16.1583 11.7405 14.933 11.7405 13.4215C11.7405 11.9099 12.9908 10.6846 14.5331 10.6846C16.0755 10.6846 17.3258 11.9099 17.3258 13.4215Z",
    fill: "white",
    stroke: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58531 13.4215C6.58531 14.933 5.33499 16.1583 3.79265 16.1583C2.25031 16.1583 1 14.933 1 13.4215C1 11.9099 2.25031 10.6846 3.79265 10.6846C5.33499 10.6846 6.58531 11.9099 6.58531 13.4215Z",
    fill: "white",
    stroke: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOrganization);
export default __webpack_public_path__ + "static/media/new-organization.14679cb2357af726c8d7aa293288496e.svg";
export { ForwardRef as ReactComponent };